import React, { useEffect, useState } from "react";
import { Calendar } from "react-multi-date-picker";
import axios from "axios";
import { toast } from "react-toastify";
import {
  getEndOfThirdMonth,
  getMonthDates,
  getMonthName,
  monthsOfYear,
} from "../../../../common/FunctionUtils";

import Layout from "components/layout/Layout";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { MonthlySummary } from "./MonthlySummary";
import { ViewDateSummary } from "./ViewDateSummary";
import { Form } from "react-bootstrap";
import CalendarSideDetails from "./CalendarSideDetails";
import Loader from "../../../../components/Loader";
import { LOCALES } from "common/constants";

export const WorkedHours = () => {
  const { t } = useTranslation();
  const currentDate = new Date();
  const getMonthDate = getMonthDates(currentDate);

  const [dateFrom, setDateFrom] = useState(getMonthDate?.formattedFirstDate);
  let endDateFormat;
  if (dateFrom !== "") {
    endDateFormat = getEndOfThirdMonth(dateFrom);
  }

  const [dateTo, setDateTo] = useState(endDateFormat);
  const [loading, setLoading] = useState(false);

  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [year, setYear] = useState(new Date().getFullYear());
  const [years, setYears] = useState([]);
  const [calendarStartDate, setCalendarStartDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [highlightedDates, setHighlightedDates] = useState([]);
  const [reservedDates, setReservedDates] = useState([]);
  const [viewDate, setViewDate] = useState([]);
  const [datesChanged, setDatesChanged] = useState(false);
  const [filterTableData, setfilterTableData] = useState([]);
  const [totalByMonth, setTotalByMonth] = useState([]);
  const [employeeSalary, setemployeeSalarys] = useState([]);
  const [monthTitle, setMonthTitle] = useState("");
  const language = localStorage.getItem("i18nextLng");

  const getYears = () => {
    const currentYear = new Date().getFullYear();
    const range = (start, stop, step) =>
      Array.from(
        { length: (stop - start) / step + 1 },
        (_, i) => start + i * step
      );
    const years = range(2023, currentYear, 1);
    years.sort((a, b) => a - b);
    setYears(years);
  };

  const handleChangeDate = (e, type) => {
    let newDate;
    if (type === "month") {
      const newMonth = e.target.value;
      newDate = new Date(year, newMonth - 1);
      setMonth(newMonth);
    } else {
      const newYear = e.target.value;
      const getMonthSplit = dateFrom?.split("-")[1];
      const month = parseInt(getMonthSplit, 10);
      newDate = new Date(newYear, month - 1);
      setYear(newYear);
    }
    setSelectedDate(newDate);
    setCalendarStartDate(newDate);
    postDatesData(newDate);
  };

  const postDatesData = async (newDate) => {
    setLoading(true);
    const currentMonth = newDate ? newDate.getMonth() + 1 : month;
    const currentYear = newDate ? newDate.getFullYear() : year;
    const firstDateOfMonth = new Date(currentYear, currentMonth - 1, 1);
    firstDateOfMonth.setDate(firstDateOfMonth.getDate() + 1);
    const formattedFirstDate = firstDateOfMonth.toISOString().split("T")[0];
    setDateFrom(formattedFirstDate);

    const threeMonthsLater = new Date(currentYear, currentMonth + 2, 1);
    threeMonthsLater.setDate(1);
    const formattedLastDate = threeMonthsLater.toISOString().split("T")[0];
    setDateTo(formattedLastDate);

    try {
      let URL = `/employeecertificate/get-working-hours`;
      // if (formattedFirstDate) {
      // URL += `?Month=${formattedFirstDate}`;
      // }
      if (formattedFirstDate && dateTo) {
        URL += `?fromDate=${formattedFirstDate}&toDate=${dateTo}`;
      }
      const result = await axios.get(URL);
      if (result?.status === 200) {
        setLoading(false);
        const response = result?.data?.response;
        setReservedDates(response?.workingHours);
        setemployeeSalarys(response?.employeeSalary);
        const dates = response?.workingHours?.map(
          (item) => new Date(item?.workingDate)
        );
        setHighlightedDates(dates);
      }
    } catch (err) {
      setLoading(false);
      toast.error(err?.response?.data?.message);
    }
  };

  const getData = async () => {
    setLoading(true);
    try {
      let URL = `/employeecertificate/get-working-hours`;
      // if (dateFrom && dateTo === undefined) {
      // URL += `?Month=${dateFrom}`;
      // }
      if (dateFrom && dateTo) {
        URL += `?fromDate=${dateFrom}&toDate=${dateTo}`;
      }
      const result = await axios.get(URL);
      if (result?.status === 200) {
        setLoading(false);
        const response = result?.data?.response;
        setReservedDates(response?.workingHours);
        setemployeeSalarys(response?.employeeSalary);
        const dates = response?.workingHours.map(
          (item) => new Date(item?.workingDate)
        );
        setHighlightedDates(dates);
      }
    } catch (err) {
      setLoading(false);
      toast.error(err?.response?.data?.message);
    }
  };

  const tileClassName = (date) => {
    const jsDateUpdate = date.toDate();
    const isSameDate = (d1, d2) =>
      d1.getDate() === d2.getDate() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getFullYear() === d2.getFullYear();
    if (highlightedDates?.length) {
      if (highlightedDates.some((d) => isSameDate(d, jsDateUpdate))) {
        return "highlighted";
      }
    }
    if (isSameDate(jsDateUpdate, currentDate)) {
      return "current-date";
    }
    if (isSameDate(jsDateUpdate, selectedDate)) {
      return "selected-date";
    }
    return null;
  };

  const normalizeDate = (date) => {
    const normalized = new Date(date);
    normalized.setHours(0, 0, 0, 0);
    return normalized;
  };

  const onChange = (date) => {
    const checkDate = normalizeDate(date.toDate());
    setDatesChanged(true);
    setSelectedDate(checkDate);
    const newMonth = checkDate.getMonth() + 1;
    const newYear = checkDate.getFullYear();
    setMonth(newMonth);
    setYear(newYear);
    setCalendarStartDate(checkDate);
    // postDatesData(checkDate);
    const filteredDates = reservedDates?.filter((item) => {
      const itemDate = normalizeDate(new Date(item?.workingDate));
      return itemDate.getTime() === checkDate.getTime();
    });
    setViewDate(filteredDates);
  };

  const handleActiveStartDateChange = ({ activeStartDate }) => {
    const newMonth = activeStartDate.getMonth() + 1;
    const newYear = activeStartDate.getFullYear();
    setMonth(newMonth);
    setYear(newYear);
    setCalendarStartDate(activeStartDate);
    postDatesData(activeStartDate);
  };

  const handleDateFromChange = (e) => {
    const selectedDate = new Date(e.target.value);
    const formattedDate = selectedDate.toISOString().split("T")[0];
    if (dateTo && selectedDate > new Date(dateTo)) {
      toast.error(t("From date cannot be greater than to date"));
      return;
    }
    setDateFrom(formattedDate);
    setMonth(selectedDate.getMonth() + 1);
    setYear(selectedDate.getFullYear());
    setSelectedDate(selectedDate);
    setCalendarStartDate(selectedDate);
    const endDateFormat = getEndOfThirdMonth(formattedDate);
    setDateTo(endDateFormat);
    setMonth("");
  };

  const handleDateToChange = (e) => {
    const selectedDate = new Date(e.target.value);
    const formattedDate = selectedDate.toISOString().split("T")[0];
    if (dateFrom && selectedDate < new Date(dateFrom)) {
      toast.error(t("To date cannot be less than from date"));
      return;
    }
    setDateTo(formattedDate);
    setMonth("");
  };

  useEffect(() => {
    if (dateFrom && dateTo) getData();
  }, [dateFrom, dateTo]);

  useEffect(() => {
    if (month && year) postDatesData();
  }, []);

  useEffect(() => {
    const getData = monthsOfYear.find((m) => m.value === month);
    if (getData) {
      setMonthTitle(getData.label);
    }
    setfilterTableData(reservedDates);
    // setDataArray(reservedDates);
  }, [reservedDates, month, selectedDate]);

  useEffect(() => {
    getYears();
  }, []);

  useEffect(() => {
    const filterDataByDateRange = (data = [], from, to, key, dateKey) => {
      const result = {};
      const fromDate = new Date(from);
      const toDate = new Date(to);
      fromDate.setHours(0, 0, 0, 0);
      toDate.setHours(23, 59, 59, 999);
      data.forEach((item) => {
        const itemDate = new Date(item[dateKey]);
        itemDate.setHours(0, 0, 0, 0);
        if (itemDate >= fromDate && itemDate <= toDate) {
          const month = itemDate.getMonth() + 1;
          const year = itemDate.getFullYear();
          const monthYear = `${year}-${month.toString().padStart(2, "0")}`;
          if (!result[monthYear]) {
            result[monthYear] = { totalHours: 0, totalAmount: 0 };
          }
          if (key === "number") {
            result[monthYear].totalHours += item.number || 0;
          } else if (key === "amount") {
            result[monthYear].totalAmount += item.amount || 0;
          }
        }
      });
      return result;
    };

    if (dateFrom && dateTo) {
      const hoursData = filterDataByDateRange(
        reservedDates,
        dateFrom,
        dateTo,
        "number",
        "workingDate"
      );
      const amountData = filterDataByDateRange(
        employeeSalary,
        dateFrom,
        dateTo,
        "amount",
        "paidDate"
      );
      const totalsByMonth = Object.entries(hoursData).map(
        ([monthYear, totals]) => ({
          monthYear,
          totalHours: totals.totalHours,
          totalAmount: amountData[monthYear]?.totalAmount || 0,
        })
      );

      setTotalByMonth(totalsByMonth);
    } else if (month && year) {
      const singleMonthFrom = new Date(year, month - 1, 1);
      const singleMonthTo = new Date(year, month, 0);

      const hoursData = filterDataByDateRange(
        reservedDates,
        singleMonthFrom,
        singleMonthTo,
        "number",
        "workingDate"
      );
      const amountData = filterDataByDateRange(
        employeeSalary,
        singleMonthFrom,
        singleMonthTo,
        "amount",
        "paidDate"
      );

      const totalsByMonth = Object.entries(hoursData).map(
        ([monthYear, totals]) => ({
          monthYear,
          totalHours: totals.totalHours,
          totalAmount: amountData[monthYear]?.totalAmount || 0,
        })
      );
      setTotalByMonth(totalsByMonth);
    }
  }, [reservedDates, employeeSalary, dateFrom, dateTo, month, year]);
  // --------------------------------Scroll on Page Load--------------------------------------
  useEffect(() => {
    if (window.innerWidth < 769) {
      window.scrollTo({ top: 1000, left: 0, behavior: "smooth" });
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
  }, []);

  return (
    <>
      <Layout
        className="p-4 mt-5 create_invoices invoice-space supplier-space"
        showSidebar
        bgcolor
      >
        <Helmet>
          {language === LOCALES.EN_US ? (
            <link
              rel="canonical"
              href="https://invozio.com/dashboard/economy/Usercalender"
            />
          ) : (
            <link
              rel="canonical"
              href="https://invozio.com/instrumentbrada/ekonomi/användarkalender"
            />
          )}
        </Helmet>
        {loading && <Loader />}

        <div className="page-content supplierLeger">
          <div className="deductions">
            <div className="deduction_txt_wrap">
              <h4 className="accident_ins font-weight-bold">
                {t("Worked Hours")}
              </h4>
            </div>
          </div>

          <div className="d-flex mt-4 mx-4">
            <div>
              <h6 className="font-weight-bold">{t("Month")}</h6>
              <div
                style={{
                  marginTop: "14px",
                }}
              >
                {/* <FormControl
                  sx={{ minWidth: 120 }}
                  size="small"
                  style={{ marginTop: "7px" }}
                >
                  <InputLabel id="demo-select-small-label">Months</InputLabel> */}
                <Form.Select
                  labelId="demo-select-small-label"
                  id="demo-select-small"
                  value={month}
                  label="Months"
                  onChange={(e) => handleChangeDate(e, "month")}
                >
                  <option disabled value="">
                    {t("Select month")}
                  </option>
                  {monthsOfYear?.map((item) => (
                    <option key={item?.value} value={item?.value}>
                      {t(item?.label)}
                    </option>
                  ))}
                </Form.Select>
                {/* </FormControl> */}
              </div>
            </div>

            <div className="mx-4">
              <h6 className="font-weight-bold">{t("Select range")}</h6>
              <div style={{ marginTop: "14px" }}>
                <input
                  type="date"
                  value={dateFrom}
                  onChange={handleDateFromChange}
                  // max={new Date().toISOString().split("T")[0]}
                  min={"2023-01-01"}
                />
                <input
                  className="mx-3"
                  type="date"
                  value={dateTo}
                  onChange={handleDateToChange}
                  // max={new Date().toISOString().split("T")[0]}
                  min={"2023-01-01"}
                />
              </div>
            </div>

            <div>
              <h6 className="font-weight-bold">{t("Year")}</h6>
              <div style={{ marginTop: "14px" }}>
                <Form.Select
                  labelId="demo-select-small-label"
                  id="demo-select-small"
                  value={year}
                  onChange={(e) => handleChangeDate(e, "year")}
                >
                  {years &&
                    years.map((item) => (
                      <option key={item} value={item}>
                        {item}
                      </option>
                    ))}
                </Form.Select>
              </div>
            </div>
          </div>

          <div className="mt-4 mx-4">
            <h6 className="mt-4">
              <span className="font-weight-bold">
                {" "}
                {t("Click any date to view calendar summary")}
              </span>
            </h6>
            <div className="d-flex">
              <div style={{ maxHeight: "200" }}>
                <Calendar
                  onChange={onChange}
                  value={selectedDate}
                  defaultView="month"
                  activeStartDate={calendarStartDate}
                  onActiveStartDateChange={handleActiveStartDateChange}
                  // maxDate={currentDate}
                  minDate={new Date(2023, 0, 1)}
                  numberOfMonths={3}
                  mapDays={({ date }) => {
                    const className = tileClassName(date);
                    return {
                      className,
                    };
                  }}
                />
              </div>
              <CalendarSideDetails
                totalByMonth={totalByMonth}
                getMonthName={getMonthName}
                t={t}
              />
            </div>
          </div>
        </div>

        {datesChanged && (
          <div className="mt-4">
            <ViewDateSummary
              viewDate={viewDate}
              datesChanged={datesChanged}
              setDatesChanged={setDatesChanged}
              t={t}
            />
          </div>
        )}

        <MonthlySummary filterData={filterTableData} t={t} />
      </Layout>
    </>
  );
};
